import { dbuiV1ListExternalLocationsOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetExternalLocations = () => {
  const { workspace } = useWorkspace();
  return useQuery({
    ...dbuiV1ListExternalLocationsOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
  });
};
